import { lazy } from "common/load/componentUtils";
import { PromotionKind } from "common/types/promotions";

import { useDrawer } from "client/common/hooks/stackables";
import { useFeatures } from "client/clinics/hooks";

import type { PromotionDrawerProps } from "../components/PromotionDrawer";
import type { RebateDrawerProps } from "../components/RebateDrawer";
import type { IncentiveDrawerProps } from "../components/IncentiveDrawer";

const PromotionDetailDrawer = lazy(() => import("../components/PromotionDrawer"));
const RebateDetailDrawer = lazy(() => import("../components/RebateDrawer"));
const IncentiveDetailDrawer = lazy(() => import("../components/IncentiveDrawer"));
const BiFreeToyDrawer = lazy(() => import("../components/BiFreeToyDrawer"));

export const useBiFreeToyDrawer = () => {
  const { open } = useDrawer();
  return {
    open: () => open(BiFreeToyDrawer),
  };
};

export const useRebateDrawer = () => {
  const { open } = useDrawer();
  return {
    open: (props: RebateDrawerProps) => open(RebateDetailDrawer, props),
  };
};

export const useIncentiveDrawer = () => {
  const { open } = useDrawer();
  return {
    open: (props: IncentiveDrawerProps) => open(IncentiveDetailDrawer, props),
  };
};

export const usePromotionDrawer = () => {
  const { open } = useDrawer();
  const rebateDrawer = useRebateDrawer();
  const incentiveDrawer = useIncentiveDrawer();
  const isProductCards = useFeatures().PROMOTION_PAGES_USE_PRODUCT_CARDS;

  const kindToDrawer = {
    [PromotionKind.Rebate]: rebateDrawer,
    [PromotionKind.Incentive]: incentiveDrawer,
  };

  return {
    open: (props: PromotionDrawerProps) => {
      if (isProductCards) {
        open(PromotionDetailDrawer, props);
        return;
      }
      const { kind, ...rest } = props;
      kindToDrawer[kind].open(rest);
    },
  };
};
